module.exports = __webpack_public_path__ + "static/media/9.60eb0874.jpg";